// Components/PDF/Summary.jsx
import { Text, View } from "@react-pdf/renderer";
import pdfStyles from "../PDF/Styles/SummaryStyles";
import {
  countUniqueArFirms,
  buildCountsByFirm,
  countUniqueTradingStyleAdvisers,
  buildCountsForTradingStyles,
} from "../../HelperFunctions/GetFormatedData";
import { CATS } from "../../HelperFunctions/GetAdviserCategories";


// Fixed category labels

const normTxt = (v) => (v ?? "").toString().trim().toLowerCase();

const hasTradingStyles = (c) => {
  const arr =
    Array.isArray(c?.tradingStyles) && c.tradingStyles.some((s) => normTxt(s));
  const single = !!normTxt(c?.tradingStyle);
  return arr || single;
};


// ---------- helpers ----------
const getKey = (c) =>
  (c?.id || c?.email || c?.contactEmail || "").toString().trim().toLowerCase();

const getTradingName = (c) =>
  (c?.tradingName || c?.tradingStyle || "").toString().trim().toLowerCase();

const normalizeStatuses = (raw) => {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .flatMap((x) =>
        String(x)
          .split(/[,;|]/)
          .map((y) => y.trim())
      )
      .filter(Boolean)
      .map((s) => s.toUpperCase());
  }
  return String(raw)
    .split(/[,;|]/)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => s.toUpperCase());
};


// ---------- component ----------
const SummaryTable = ({ data }) => {
  const ars = data.filter((x) => x.isAR === true);
  const trading = data.filter((x) => !x.isAR);

  const totalAR = countUniqueArFirms(ars);
  const totalTrading = countUniqueTradingStyleAdvisers(trading);

  const arCounts = buildCountsByFirm(ars, CATS);
  const tradingCounts = buildCountsForTradingStyles(trading, CATS);

  // Adviser-based counts across ALL advisers (AR + Trading)
  const individualCounts = buildCountsForTradingStyles(data, CATS);

  const combinedCounts = { ...individualCounts };

  const totalCombined = Object.values(combinedCounts).reduce(
    (a, b) => a + b,
    0
  );

  return (
    <View break style={pdfStyles.wrapper}>
      <View style={pdfStyles.table}>
        <View style={pdfStyles.headerRow}>
          <Text style={pdfStyles.headerLabel}>IFA Advisers</Text>
          <Text style={pdfStyles.headerCount}>No.</Text>
        </View>

        {CATS.map((label) => (
          <View key={label} style={pdfStyles.row}>
            <Text style={pdfStyles.cellLabel}>{label}</Text>
            <Text style={pdfStyles.cellCount}>{combinedCounts[label]}</Text>
          </View>
        ))}

        <View style={pdfStyles.totalRow}>
          <Text style={pdfStyles.totalLabel}>Total</Text>
          <Text style={pdfStyles.totalCount}>{totalCombined}</Text>
        </View>
      </View>

      <Text style={{ ...pdfStyles.totalsText, marginTop: 20 }}>
        Total Appointed Representatives: {totalAR}
      </Text>
      <Text style={pdfStyles.totalsText}>
        Total Advisers in Trading Styles: {totalTrading}
      </Text>

      {/* footer unchanged */}
      <Text style={pdfStyles.footer}>
        Rosemount Financial Solutions (IFA) Ltd is authorised and regulated by
        the Financial Conduct Authority (FCA). Entered on the FCA Register
        (https://register.fca.org.uk/) under reference 535515. Rosemount
        Financial Solutions (IFA) Ltd is registered in England and Wales,
        Registered No. 05668905. Registered Address: Rosemount House, 2–4
        Chequers Road, Basingstoke, RG21 7PU.
      </Text>
    </View>
  );
};
export default SummaryTable;
